// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"3b5b04c5","186":"5a804ebc","272":"cfd1f14a","372":"3128ace9","377":"8cae9bb8","630":"3bf437af","738":"e448038f","841":"31ecc7a7","851":"9fcf1193","856":"636cef5f"}[chunkId] + ".chunk.js";
};